export const getRegion = () => {
  let region = localStorage.getItem('region'); // dev method

  if (!region) {
    region = getDefinedRegion();
    localStorage.setItem('region', region);
  }

  return region;
};

export function getDefinedRegion() {
  const host = window.location.host;

  switch (host) {
    case 'sixtix.rs':
    case 'de.sixtix.rs':
      return 'rs';

    case 'sixtix.fr':
    case 'dev.sixtix.fr':
      return 'fr';

    case 'sixtix.nl':
    case 'dev.sixtix.nl':
      return 'nl';

    default:
      return 'com';
  }
}
